import React from 'react'
import PropTypes from 'prop-types'
import PerformanceItem from '../PerformanceItem'

function FrequencyModal() {
	return (
		<div className='performance_item_modal frequency_modal'>
			<h3>Frequency</h3>
			<p>
				Frequency is crucial to avoiding ad exhaustion among your audience.
			</p>
			<p>
				If they see it too often, your message loses its impact (and may annoy some users in the process), and if it&apos;s seen too infrequently, your message may not resonate at all.
			</p>
			<p>
				Consider the type of creative you have (e.g. video, photo, link) and campaign objective to help gauge the optimal frequency.
			</p>
		</div>
	)
}

const renderFrequencyBody = (value) => {
	if(value===null) {
		return (
			<p>We could not collect your frequency since you have not run ads in the past 30 days.</p>
		)
	} else {
		return (
			<p>You have been rotating your creative at a frequency of {value}, which increases ad effectiveness.</p>
		)
	}
}

function FrequencyPerformanceItem(props) {
	const { score, maxScore, value } = props.apiScore

	return (
		<PerformanceItem
			title="Frequency"
			score={score}
			maxScore={maxScore}
			showPerformanceModal={() => { props.showPerformanceModal('frequency') }}>
			{renderFrequencyBody(value)}
		</PerformanceItem>
	)
}
FrequencyPerformanceItem.propTypes = {
	apiScore: PropTypes.object,
	showPerformanceModal: PropTypes.func
}


export { FrequencyModal, FrequencyPerformanceItem }


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/performance_items/Frequency.js